import { Routes } from '@angular/router';

export const writeReviewRoutes: Routes = [
  {
    path: 'write-review/:verticalType/:referralId',
    children: [
      {
        path: '',
        loadChildren: () => import('@rma/reviews/review-flow'),
      },
      {
        path: 'unsubscribe',
        title: 'Unsubscribed from review request',
        loadComponent: () => import('@rma/reviews/review-unsubscribe'),
      },
    ],
  },
];
